import { gql } from "graphql-request";

export const SHOWDATES_QUERY = gql`
query ($locations: [String], $firmId: Int, $excludeMovieIdPrefixes: [String]) {
    showQuery {
        getShowDates (locations: $locations, excludeMovieIdPrefixes: $excludeMovieIdPrefixes, firmId: $firmId) {
            date
        }
    }
}`;

export const PROGRAM_FOR_DATE_QUERY = gql`
query($date: String, $locations: [String], $firmId: Int) {
	movieQuery {
		getCurrentMovies(date: $date, locations: $locations, removePastShows: true, firmId: $firmId) {
			__typename
			mainVersionId
			premiere
			title
			isKinoklubb
			genres
			lengthInMinutes
			rating
			sanityImagePosterUrl
			externalImagePosterUrl
			shows {
				__typename
				id
				firmName
				showStart
				screenName
				showType
				isKinoklubb
				ticketSaleUrl
				theaterName
				theaterId
				movieVersionId
                movieTitle
				versionTags {
					tag
					type
				}
			}
		}

	}
}`;